import * as Yup from 'yup';

interface RoomPlannerValues {
    width: number;
    length: number;
    rightWidth: number;
    rightDepth: number;
    leftWidth: number;
    leftDepth: number;
}

export const validationSchema = Yup.object().shape({
    width: Yup.number().min(1000, 'Minimum width is 1000mm'),
    length: Yup.number().min(1000, 'Minimum length is 1000mm'),
    rightWidth: Yup.number()
        .min(1000, 'Minimum right width is 1000mm')
        .test(
            'rightWidth-min-leftDepth-plus-1000',
            'Right width cannot be less than left depth + 1000mm',
            (rightWidth, context) => {
                const {leftDepth} = context.parent as RoomPlannerValues;
                if (!rightWidth || !leftDepth) return true;
                const min = leftDepth + 1000;
                return (
                    rightWidth >= min ||
                    context.createError({
                        message: `Right width cannot be less than ${min}mm`,
                    })
                );
            }
        ),
    rightDepth: Yup.number()
        .min(1000, 'Minimum right depth is 1000mm')
        .test(
            'rightDepth-max',
            'Right depth cannot be greater than left width minus 1000mm',
            (rightDepth, context) => {
                const {leftWidth} = context.parent as RoomPlannerValues;
                if (!rightDepth || !leftWidth) return true;
                const max = leftWidth - 1000;
                return (
                    rightDepth <= max ||
                    context.createError({
                        message: `Right depth cannot be greater than ${max}mm`,
                    })
                );
            }
        ),
    leftWidth: Yup.number()
        .min(1000, 'Minimum left width is 1000mm')
        .test(
            'leftWidth-min-rightDepth-plus-1000',
            'Left width cannot be less than right depth + 1000mm',
            (leftWidth, context) => {
                const {rightDepth} = context.parent as RoomPlannerValues;
                if (!leftWidth || !rightDepth) return true;
                const min = rightDepth + 1000;
                return (
                    leftWidth >= min ||
                    context.createError({
                        message: `Left width cannot be less than ${min}mm`,
                    })
                );
            }
        ),
    leftDepth: Yup.number()
        .min(1000, 'Minimum left depth is 1000mm')
        .test(
            'leftDepth-max',
            'Left depth cannot be greater than right width minus 1000mm',
            (leftDepth, context) => {
                const {rightWidth} = context.parent as RoomPlannerValues;
                if (!leftDepth || !rightWidth) return true;
                const max = rightWidth - 1000;
                return (
                    leftDepth <= max ||
                    context.createError({
                        message: `Left depth cannot be greater than ${max}mm`,
                    })
                );
            }
        ),
});
